import { TEXTS } from '../../texts';
import type { PromoStatus } from '../types';

export const PROMO_STATUS_TITLE_BY_STATUS: Record<PromoStatus, string> = {
  active: TEXTS.AUDIO_REPORT_PROMOS_STATUS_ACTIVE,
  passed: TEXTS.AUDIO_REPORT_PROMOS_STATUS_PASSED,
  planned: TEXTS.AUDIO_REPORT_PROMOS_STATUS_PLANNED,
  stopped: TEXTS.AUDIO_REPORT_PROMOS_STATUS_STOPPED,
};
